import { createContext, useCallback, useContext, useState } from 'react';
import { getAccessToken, getAutoLogin, getRefreshToken, setAccessToken, setAutoLogin } from './services/storage';
import jwt from 'jsonwebtoken';
import { userAutoLogin } from './services/api';

const getToken = () => {
  return {
    accessToken: getAccessToken(),
    refreshToken: getRefreshToken(),
  };
};

type Props = {
  userInfo: AccountUserInfo;
  isLogin: boolean;
  isInit: boolean;
  init: () => void;
  refreshLogin: () => boolean | AccountUserInfo;
  login: (token: AccountTokenData) => AccountUserInfo | void;
  logout: () => void;
  getToken: () => AccountTokenData;
};

const UserContext = createContext<Props>({} as Props);

export const UserContextProvider = ({ children }: { children: JSX.Element }): JSX.Element => {
  const [userInfo, setUserInfo] = useState({} as AccountUserInfo);
  const [isLogin, setIsLogin] = useState(false);
  const [isInit, setIsInit] = useState(false);

  const login = useCallback((token: AccountTokenData) => {
    const userInfo = jwt.decode(token.accessToken) as AccountUserInfo;
    console.log(`%c User Login`, 'background: orange; color: white', userInfo);
    setUserInfo(userInfo);
    setIsLogin(true);
    return userInfo;
  }, []);

  const logout = useCallback(() => {
    console.log(`%c User Logout`, 'background: orange; color: white');
    setUserInfo({} as AccountUserInfo);
    setIsLogin(false);
    setAutoLogin(false);
    setAccessToken('');
  }, []);

  const refreshLogin = useCallback(() => {
    const { accessToken, refreshToken } = getToken();
    if (refreshToken && accessToken) {
      return login({
        refreshToken,
        accessToken,
      });
    } else {
      logout();
      return false;
    }
  }, []);

  const onInit = useCallback(() => {
    const { accessToken, refreshToken } = getToken();
    const autoLogin = getAutoLogin();
    if (refreshToken && accessToken) {
      login({
        refreshToken,
        accessToken,
      });
      setIsInit(true);
    } else {
      console.log(11, autoLogin, refreshToken);
      if (autoLogin && refreshToken) {
        userAutoLogin(refreshToken)
          .then((res) => {
            console.log(`%c User Auto Login`, 'background: orange; color: white', res);
            login(res);
            setIsInit(true);
          })
          .catch((e) => {
            logout();
            setIsInit(true);
            console.warn(e);
          });
      } else {
        logout();
        setIsInit(true);
      }
    }
  }, []);

  return (
    <UserContext.Provider
      value={{
        userInfo,
        isLogin,
        isInit,
        init: onInit,
        refreshLogin,
        login,
        logout,
        getToken,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const useUser = (): Props => useContext(UserContext);
